import { render, staticRenderFns } from "./pickupServiceDashboard.vue?vue&type=template&id=dd9e2a8a"
import script from "./pickupServiceDashboard.vue?vue&type=script&lang=js"
export * from "./pickupServiceDashboard.vue?vue&type=script&lang=js"
import style0 from "./pickupServiceDashboard.vue?vue&type=style&index=0&id=dd9e2a8a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd9e2a8a')) {
      api.createRecord('dd9e2a8a', component.options)
    } else {
      api.reload('dd9e2a8a', component.options)
    }
    module.hot.accept("./pickupServiceDashboard.vue?vue&type=template&id=dd9e2a8a", function () {
      api.rerender('dd9e2a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/pickupServiceDashboard.vue"
export default component.exports